// Platform-specific "how to install the VisiSmart Code" guides.
// Shared by onboarding and the funnel "SmartCode not detected" modal so both
// always point at the same document for a given website platform.
export type SmartCodePlatform =
  | 'custom'
  | 'react'
  | 'angular'
  | 'vue'
  | 'next'
  | 'astro'
  | 'framework_other'
  | 'shopify'
  | 'ghl'
  | 'wordpress'
  | 'emdash';

export function frameworkToPlatform(frontEndFramework: any, frameworkType: any): SmartCodePlatform {
  const fef = String(frontEndFramework ?? '0');
  const ft = String(frameworkType ?? '1');
  if (fef === '2') return 'shopify';
  if (fef === '3') return 'ghl';
  if (fef === '4') return 'wordpress';
  if (fef === '5') return 'emdash';
  if (fef === '1') {
    const map: Record<string, SmartCodePlatform> = {
      '1': 'react',
      '2': 'angular',
      '3': 'vue',
      '4': 'next',
      '5': 'framework_other',
      '6': 'astro',
    };
    return map[ft] || 'framework_other';
  }
  return 'custom';
}

export const SMART_CODE_GUIDE: Record<SmartCodePlatform, string> = {
  custom: 'https://visiopt.com/help-videos/settings.html',
  react: 'https://visiopt.zendesk.com/hc/en-us/articles/50370205260315-React-Adding-VisiSmart-Scripts',
  vue: 'https://visiopt.zendesk.com/hc/en-us/articles/50370643355419-Vue-JS-Adding-VisiSmart-Scripts',
  next: 'https://visiopt.zendesk.com/hc/en-us/articles/50370908220827-Next-JS-Adding-VisiSmart-Scripts',
  angular: 'https://visiopt.zendesk.com/hc/en-us/articles/50370364844443-Angular-Adding-VisiSmart-Scripts',
  astro: 'https://visiopt.zendesk.com/hc/en-us/articles/53912955879579-Adding-the-VisiSmart-Code-to-an-Astro-Website',
  framework_other: 'https://visiopt.com/help-videos/settings.html',
  ghl: 'https://visiopt.zendesk.com/hc/en-us/articles/30942434989211-Go-High-Level-GHL-Onboarding',
  shopify: 'https://visiopt.com/help-videos/shopify-onboarding.html',
  wordpress: 'https://visiopt.zendesk.com/hc/en-us/articles/49757661648027-WordPress-Adding-VisiSmart-Scripts',
  emdash: 'https://visiopt.zendesk.com/hc/en-us/articles/53913234208283-How-to-Install-the-Visiopt-Plugin-in-EMdash-CMS',
};

// Install guide for a website's framework fields. Falls back to the generic settings doc.
export function smartCodeGuideFor(frontEndFramework: any, frameworkType: any): string {
  return SMART_CODE_GUIDE[frameworkToPlatform(frontEndFramework, frameworkType)] || SMART_CODE_GUIDE.custom;
}
